import React, { FC } from 'react'
import { Spacer } from 'components/Utility'
import { Caution } from 'components/Typography'

type Props = {
  isError: boolean
  error: string
}

const ErrorDescription: FC<Props> = React.memo((props) => {
  const { isError, error } = props

  if (isError) {
    return (
      <>
        <Spacer size={4} />
        <Caution caution={error} />
      </>
    )
  } else {
    return <></>
  }
})

export default ErrorDescription
